import { IApiTokenBody } from "../../../@types/api-token.type";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";

export const addOrUpdateApiToken = async (apiToken: IApiTokenBody) => {
    try {
        const { data } = await Api.post(`/api/ApiToken/AddApiToken`, apiToken);
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao adcionar um Api Token'))
    }
}

export const getAllApiTokens = async () => {
    try {
        const { data } = await Api.get(`/api/ApiToken/GetAllApiTokens`)
        return data.result
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar todas as Api Tokens'))
    } 
}

export const deleteApiToken = async (id: string) => {
    try {
        await Api.delete(`/api/ApiToken/DeleteApiToken/${id}`);
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao deletar Api Token'))
    } 
};